import React from "react";
import styles from "./Tertiary.module.scss";
import SVG from "react-inlinesvg";
import OvalSpinner from "../../OvalSpinner";
import { TYPE_BUTTON } from "../types";

const WIDTH__DEFAULT = "16px";
const HEIGHT_DEFAULT = "16px";
const COLOR_DEFAULT = "#4193de";
const COLOR_IS_LOADING = "#4193de";
const ICON_COLOR = "#222";
const BKD_DEFAULT = "#D0E4F7";
const BKD_IS_LOADING = "#d4e6f7";
const FONT_WEIGHT = "400";

export default function Tertiary(TertiaryProps) {
  const {
    onClick,
    isLoading,
    type,
    disabled,
    label,
    icon,
    iconColor,
    fontWeight,
    left
  } = TertiaryProps;

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type ?? TYPE_BUTTON.BUTTON}
      className={styles.tertiaryButton}
      style={{
        "--backgroundColor": isLoading ? BKD_IS_LOADING : BKD_DEFAULT,
      }}
    >
      {isLoading && (
        <OvalSpinner height={HEIGHT_DEFAULT} width={WIDTH__DEFAULT} />
      )}

      {icon && (
        <div className={styles.iconWrapper}>
          <SVG
            src={icon}
            style={{
              "--iconColor": iconColor ?? ICON_COLOR,
              "--fontWeight": fontWeight ?? FONT_WEIGHT,
            }}
          />
        </div>
      )}
      {left && (
        <div className={styles.iconWrapper}>
          {left}
        </div>
      )}
      <span
        style={{
          "--color": isLoading ? COLOR_DEFAULT : COLOR_IS_LOADING,
        }}
        className={styles.textWrapper}
      >
        {label}
      </span>
    </button>
  );
}
